<template>
  <h1>Feedback</h1>
</template>

<script>
export default {
  name: 'Feedback'
}
</script>